import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import "./consultorias_prestadas.css";
import "./testimonials.css";
import { getTestimonials } from "../../providers/testimonialsProvider";

class Testimonials extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: []
    };
  }

  async componentDidMount() {
    const result = await getTestimonials();
    if (result.error) {
      return;
    }
    //console.log(result);

    this.setState({ list: result });
  }

  render() {
    return (
      <section id="testimonials">
        <h2 className="textoSecao"> Depoimentos de clientes </h2>
        <Row>
          {this.state.list.map((item, index) => (
            <Col lg="4" md="6" className="testimony" key={`testimony-${index}`}>
              <div className="testimony-header">
                <img className="testimony-photo" src={item.userPhoto} />
                <h4>{item.userName}</h4>
              </div>
              <div className="testimony-body">
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </section>
    );
  }
}

export default Testimonials;
